import React, { useState, useContext } from 'react';
import { TransactionContext } from '../../../contexts/TransactionContext';

function SalesScreen() {
  const { cart, addItem } = useContext(TransactionContext);
  const [searchTerm, setSearchTerm] = useState('');

  return (
    <div className="sales-container">
      {/* Product Search */}
      <input
        type="text"
        placeholder="Search products..."
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
      />

      {/* Add to Cart */}
      <button
        type="button"
        onClick={() => addItem({
          id: Date.now(),
          name: 'Custom Item',
          price: 9.99,
        })}
      >
        Add Custom Item
      </button>

      {/* Order Summary (same as POS!) */}
      <div className="order-summary">
        {cart.map((item) => (
          <div key={item.id}>
            {item.name}
            {' '}
            - $
            {item.price}
          </div>
        ))}
      </div>
    </div>
  );
}

export default SalesScreen;
